/**
 * 课程模块
 **/

import {
    COLLECT_COURSE,
    INIT_COURSE_INFO,
    LAST_STUDY_SECTION,
    SWITCH_SECTION
} from "@constants/action-type/course-action-type";
import {changeProgress, collectCourse, courseDetail, courseStudyDate, switchSection} from "@api/courese-detail";
import {SUCCESS} from "@constants/code";
import { showSuccessMsg} from "@utils/msg";
import {CHANGE_CURRENT_TIME} from "@constants/mutation-type/course-mutation-type";

export default {
    namespaced: true,
    state: {
        isLoadCourse: false,
        courseInfo: {},
        score: 5,
        // 是否支付
        isPaid: false,
        // 是否收藏
        isCollect: false,
        isLoadCollect: false,
        // 是否已经加入购物车
        isInShoppingCart: false,
        // 选中章节
        selectedSection: {},
        // 是否能学习章节
        canStudyCourse: false,
        // 加载章节
        isLoadSection: false,
        currentTime: 0
    },
    getters: {},
    mutations: {
        changeCourseLoad(state, payload) {
            state.isLoadCourse = payload.isLoadCourse;
        },
        initCourseInfo(state, payload) {
            state.courseInfo = payload.courseInfo;
            state.isPaid = payload.isPaid;
            state.isInShoppingCart = payload.isInShoppingCart;
            state.isCollect = payload.isCollect;
            state.score = payload.score;
        },
        changeSectionLoad(state, payload) {
            state.isLoadSection = payload.isLoadSection;
        },
        changeSection(state, payload) {
            state.selectedSection = payload.selectedSection;
            state.canStudyCourse = payload.canStudyCourse;
        },
        changeCollectLoad(state, payload) {
            state.isLoadCollect = payload.isLoadCollect;
        },
        changeCollect(state, {isCollect}) {
            state.isCollect = isCollect;
        },
        // 修改是否加入购物车
        changeInShoppingCart(state, {isInShoppingCart}) {
            state.isInShoppingCart = isInShoppingCart;
        },
        [CHANGE_CURRENT_TIME](state, {currentTime}) {
            state.currentTime = currentTime;
        }
    },
    actions: {
        [INIT_COURSE_INFO]({commit}, payload) {
            // 加载课程详情
            commit('changeCourseLoad', {isLoadCourse: true});
            courseDetail(payload.courseId).then((res) => {
                if (res.code === SUCCESS) {
                    commit('initCourseInfo', {
                        courseInfo: res.data,
                        isCollect: res.isCollect,
                        isInShoppingCart: res.isInShoppingCart,
                        isPaid: res.isPaid,
                        score: res.score
                    });
                    // 结束加载
                    commit('changeCourseLoad', {isLoadCourse: false});
                }
            });
        },
        [LAST_STUDY_SECTION]({commit}, payload) {
            commit('changeSectionLoad', {isLoadSection: true});
            courseStudyDate(payload.courseId).then((res) => {
                if (res.code === SUCCESS) {
                    commit('changeSection', {
                        canStudyCourse: res.canStudyCourse,
                        selectedSection: res.section || {}
                    });
                    commit('changeSectionLoad', {isLoadSection: false});
                }
            })
        },
        [SWITCH_SECTION]({state, commit, dispatch,rootState}, {sectionId, currentTime}) {
            //    修改学习进度（页面销毁前，章节切换前）
            if (rootState.login.isLogin && state.currentTime &&state.selectedSection.sectionId) {
                changeProgress(currentTime, state.selectedSection.sectionId).then(res => {
                    if (res.code === SUCCESS) {
                        // 更新一下章节列表
                        dispatch(INIT_COURSE_INFO, {courseId: state.courseInfo.courseId})
                    }
                });
            }
            // 显示加载中
            commit('changeSectionLoad', {isLoadSection: true});
            // 切换章节
            switchSection(sectionId).then((res) => {
                if (res.code === SUCCESS) {
                    commit('changeSection', {
                        canStudyCourse: res.canStudyCourse,
                        selectedSection: res.section || {}
                    });
                    commit('changeSectionLoad', {isLoadSection: false});
                }
            })
        },
        [COLLECT_COURSE]({commit, state}, {courseId}) {
            commit('changeCollectLoad', {isLoadCollect: true});
            return collectCourse(courseId).then((res) => {
                if (res.code === 0) {
                    showSuccessMsg('收藏成功');
                    commit('changeCollect', {isCollect: !state.isCollect});
                }
                commit('changeCollectLoad', {isLoadCollect: false});
                return res;
            })
        }
    }
}
